import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export function useIsSignInMobile() {
  const theme = useMantineTheme();

  return useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
}
